import { render, staticRenderFns } from "./AttrRelationPage.vue?vue&type=template&id=0761d857&scoped=true&"
import script from "./AttrRelationPage.vue?vue&type=script&lang=js&"
export * from "./AttrRelationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0761d857",
  null
  
)

export default component.exports